import { FC } from "react";
import "./Footer.scss";

const Footer: FC = () => (
  <footer className="footer" data-testid="footer">
    <div className="logo loginex-logo" />
  </footer>
);

export default Footer;
